import React from "react";
import { ArrowRight, PencilRuler, Settings2, ShieldCheck, ClipboardCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  id: "01",
  title: "Projeto",
  description: "Engenharia térmica de precisão para novas instalações. Dimensionamento rigoroso conforme normas técnicas para máxima eficiência energética e confiabilidade em ambientes críticos.",
  link: "/SolutionsPage",
  icon: "PencilRuler"
}, {
  id: "02",
  title: "Retrofit",
  description: "Modernização de sistemas existentes. Atualização tecnológica de chillers e automação para recuperar performance, estender a vida útil e reduzir custos operacionais.",
  link: "/SolutionsPage",
  icon: "Settings2"
}, {
  id: "03",
  title: "Manutenção",
  description: "Planos preventivos e corretivos especializados. Monitoramento constante e gestão de ativos para garantir disponibilidade total e segurança em operações ininterruptas.",
  link: "/SolutionsPage",
  icon: "ShieldCheck"
}, {
  id: "04",
  title: "Comissionamento",
  description: "Validação e start-up certificado. Testes de performance e integração de sistemas para assegurar que a operação atenda estritamente aos parâmetros do projeto original.",
  link: "/SolutionsPage",
  icon: "ClipboardCheck"
}];
const iconMap = {
  PencilRuler: PencilRuler,
  Settings2: Settings2,
  ShieldCheck: ShieldCheck,
  ClipboardCheck: ClipboardCheck
};
export default function EngineeringCycle() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="ciclo-completo-de-engenharia" className="relative w-full py-24 bg-secondary/50 overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="mb-16 max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground tracking-tight mb-4">
            Ciclo Completo de Engenharia
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Soluções térmicas inteligentes e confiáveis, desde a concepção técnica até a manutenção de ativos críticos.
          </p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {services.map((service, i) => {
          const IconComponent = iconMap[service.icon as keyof typeof iconMap];
          return <div key={service.id} data-index={i} className="flex flex-col h-full p-8 bg-background border border-border rounded-lg group hover:border-primary/30 transition-all duration-300">
                <div className="flex items-center justify-between mb-6">
                  <div className="p-3 bg-primary/5 rounded-md text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <IconComponent className="h-6 w-6" strokeWidth={2} />
                  </div>
                  <span className="font-mono text-xs font-bold text-muted-foreground/50 tracking-widest">
                    {service.id}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-foreground mb-4 tracking-tight group-hover:text-primary transition-colors">
                  {service.title}
                </h3>

                <p className="text-muted-foreground text-sm leading-relaxed mb-8 flex-grow">
                  {service.description}
                </p>

                <div className="mt-auto pt-6 border-t border-border/50">
                  <Link to={service.link} className="inline-flex items-center text-sm font-bold text-primary hover:text-primary-600 transition-colors group/link">
                    Ver detalhes
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover/link:translate-x-1" />
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}